module.exports = __webpack_public_path__ + "static/media/evangelion_screen3.88988650.gif";